import { useEffect, useState } from 'react';
import { getCity, isDynamicLoaded, fetchDynamicCities } from '../lib/cities-data';

/**
 * Resolve a city by slug: static list first (synchronous), then the communes added through the
 * public search (fetched once). Returns { city, loading } — `loading` is true only while the
 * dynamic list is being fetched for an unknown slug.
 */
export function useCity(slug) {
  const [state, setState] = useState(() => {
    const city = getCity(slug);
    return { city, loading: !city && !isDynamicLoaded() };
  });

  useEffect(() => {
    let cancelled = false;
    const city = getCity(slug);
    if (city || isDynamicLoaded()) {
      setState({ city, loading: false });
      return undefined;
    }
    setState({ city: undefined, loading: true });
    fetchDynamicCities().then(() => { if (!cancelled) setState({ city: getCity(slug), loading: false }); });
    return () => { cancelled = true; };
  }, [slug]);

  return state;
}
